import {LockOutlined, UserOutlined} from '@ant-design/icons';
import {Card, Form, Input, Button, message, Typography} from "antd";
import {useNavigate} from "react-router-dom";
import http from "../framework/http.js";

// Ignore ResizeObserver error (antd update error)
window.addEventListener('error', function onError(e) {
    if (e.message === 'ResizeObserver loop completed with undelivered notifications.' ||
        e.message === 'ResizeObserver loop limit exceeded') {
        const resizeObserverErr = document.getElementById("webpack-dev-server-client-overlay",);
        if (resizeObserverErr) {
            resizeObserverErr.className = "hide-resize-observer-error";
        }
    }
});

function Login() {
    const navigate = useNavigate();
    const [messageApi, messageContextHolder] = message.useMessage();
    const {Title} = Typography;

    async function onFinish(formData) {
        messageApi.open({
            type: 'loading',
            content: 'logging in...',
            duration: 0
        });

        try {
            var res = await http.post("/login", formData);
        } catch (e) {
            messageApi.destroy();
            message.error("server error, please try again later");
            return;
        }

        if (res.data.code === 200) {
            messageApi.destroy();
            message.success("login success");
            window.localStorage.setItem("token", res.data.token);
            navigate("/admin", {replace: true});
        } else {
            messageApi.destroy();
            message.error(res.data.msg);
        }

    }

    return (
        <div id="loginBody">
            {messageContextHolder}
            <Card id="container" styles={{body: { paddingBottom: 0 }}}>
                <Title level={3} style={{textAlign: "center", margin: "0px 0px 25px 0px"}}>Back Control</Title>
                <Form className="login-form" onFinish={onFinish}>
                    <Form.Item
                        name="username"
                        rules={[
                            {
                                required: true,
                                message: 'Please input your Username!',
                            }
                        ]}
                    >
                        <Input prefix={<UserOutlined className="site-form-item-icon"/>} placeholder="Username" size="large"/>
                    </Form.Item>
                    <Form.Item
                        name="password"
                        rules={[
                            {
                                required: true,
                                message: 'Please input your Password!',
                            },
                            {
                                min: 4,
                                message: "Minimum length 4",
                                validateTrigger: "onsubmit"
                            }
                        ]}
                    >
                        <Input.Password
                            prefix={<LockOutlined className="site-form-item-icon"/>}
                            type="password"
                            placeholder="Password"
                            size="large"
                        />
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit" className="login-form-button">
                            Log in
                        </Button>
                        {/*<a>Register now</a>*/}
                    </Form.Item>
                </Form>

            </Card>
        </div>
    );
}

export default Login;
